import type { CSSProperties, MouseEventHandler, ReactNode } from "react"
import { Link } from "@inertiajs/react"
import { cn } from "../utils/cn"

type Props = {
  href: string
  label: string
  tone?: "primary" | "secondary" | "soft"
  external?: boolean
  download?: boolean | string
  className?: string
  style?: CSSProperties
  icon?: ReactNode
  onClick?: MouseEventHandler<Element>
}

export function ActionButton({ href, label, tone = "primary", external, download, className, style, icon, onClick }: Props) {
  const isExternal = external ?? /^(https?:|mailto:|tel:|sms:|whatsapp:|\/\/)/.test(href)
  const openInNewTab = /^(https?:|\/\/)/.test(href)
  const buttonClassName = cn(
    "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-medium transition",
    tone === "primary" && "bg-brand-600 text-white shadow-soft hover:bg-brand-700",
    tone === "secondary" && "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
    tone === "soft" && "bg-brand-50 text-brand-800 hover:bg-brand-100",
    className,
  )

  return isExternal || download ? (
    <a
      href={href}
      className={buttonClassName}
      style={style}
      download={download}
      {...(openInNewTab && !download ? { target: "_blank", rel: "noreferrer" } : {})}
      onClick={onClick}
    >
      {icon}
      {label}
    </a>
  ) : (
    <Link href={href} className={buttonClassName} style={style} onClick={onClick}>
      {icon}
      {label}
    </Link>
  )
}
